import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  SubmitButton: {
    display: 'block',
    borderRadius: 8,
    fontSize: 14,
    width: 'calc(100%)',
    height: 40,
    margin: '30px 0 0',
    background: '#FF9B07',
    transform: 'scale(0.99)',
    color: '#fff',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FF9B07',
      color: 'white',
    },
    '&:disabled': {
      color: '#43566C',
      cursor: 'default',
      backgroundColor: 'rgb(14 17 27)',
    },
    '&:active': {
      backgroundColor: '#FF9B07',
      boxShadow:
        '0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08), inset 0 1px 0 #FF9B07',
      transform: 'scale(0.99)',
    },
  },

  CancelButton: {
    display: 'block',
    fontSize: 14,
    width: 'calc(100%)',
    height: 40,
    margin: '20px 0 0',
    backgroundColor: theme.colors.dark.steelBlue,
    boxShadow:
      '0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08),inset 0 1px 0 #43566C',
    borderRadius: 8,
    color: '#fff',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 100ms ease-in-out',
    willChange: 'transform, background-color, box-shadow',
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: 'white',
    },
    '&:active': {
      backgroundColor: theme.colors.dark.steelBlue,
      boxShadow:
        '0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08), inset 0 1px 0 #43566C',
      transform: 'scale(0.99)',
    },
  },

  PaymentText: {
    marginBottom: 5,
    fontWeight: 700,
    fontSize: 20,
    color: 'white',
  },
  Form: {
    marginTop: 70,
    paddingLeft: 20,
    paddingRight: 20,
    animation: 'fade 200ms ease-out',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
      marginLeft: '22%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
      marginLeft: '23%',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 20,
    backgroundColor: theme.colors.dark.midnightBlue,
    borderRadius: 18,
  },
  formTypeButton: {
    background: '#303C50',
    color: 'white',
    paddingLeft: '20px',
    paddingRight: '20px',
    borderRadius: '8px',
    textTransform: 'none',
    height: 45,
  },

  formTypeButtonActive: {
    background: 'rgb(14 17 27)',
    color: '#FF9B07',
    border: '2px solid #FF9B07',
    paddingLeft: '20px',
    paddingRight: '20px',
    borderRadius: '8px',
    textTransform: 'none',
    height: 45,
  },
  spanLine: {
    height: 1,
    width: '100%',
    border: 'none',
    display: 'flex',
    backgroundColor: '#43566C',
  },
  divFormType: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  divCardIcon: {
    background: '#303C50',
    height: '100%',
    borderRadius: 6,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  divCardHolder: {
    background: 'rgb(33,34,49)',
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
    padding: 20,
  },
  textCardHolder: {
    border: '1px solid #43566C',
    borderRadius: 9,
    padding: 5,
    paddingLeft: 15,
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBackdrop-root': {
      background: 'rgba(2, 7, 20, 0.6) !important',
      backdropFilter: 'blur(5px) !important',
    },
  },
  paper: {
    position: 'absolute',
    zIndex: -1,

    background: '#1b2440',
    width: 327,
    height: 150,
    marginTop: -40,
    textAlign: 'center',
    padding: '10px 15px',
    border: 'none',
    boxShadow: '0px 8px 12px rgba(3, 6, 23, 0.5)',
    borderRadius: 28,
    '&:focus': {
      outline: 'none !important',
    },
  },
  ModalHeading: {
    textAlign: 'center',
    fontSize: 15,
    fontFamily: theme.fonts.family.primary,
    color: theme.colors.light.freshPowder,
    fontWeight: 500,
    marginTop: 55,
    marginBottom: 5,
  },
  ModalSubHeading: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.fonts.sizes.font16PX,
    fontFamily: theme.fonts.family.primary,
    color: theme.colors.light.lightSteelBlue,
    fontWeight: 500,
    marginBottom: 15,
  },
}));
